import { computed } from 'vue';
import { useRouter } from 'vue-router';

import { useUserStore } from '@/stores/user';

export function useButtonBackIos() {
  const userStore = useUserStore();
  const router = useRouter();

  // 뒤로가기 버튼이 보이는지 (아이폰, 어플에서만)
  const isVisibleButtonBack = computed(() => {
    const { os, isInApp } = userStore.userDeviceInfo;
    return isInApp && os === 'iOS';
  });

  // 아이폰 어플 뒤로가기 버튼 클릭 시
  const onClickButtonBack = () => {
    router.replace({ name: 'native-dashboard' });
  };

  return { isVisibleButtonBack, onClickButtonBack };
}
